import { useMsal } from '@azure/msal-react';
import { useStyles } from './betriebsereignisseStyle';
import { globalStyles } from '../../assets/globalStyles';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import React, { ReactElement, useEffect } from 'react';
import { Error, Cancel, CheckCircle, AssignmentTurnedIn } from '@material-ui/icons';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import ForumIcon from '@material-ui/icons/Forum';
import { Button, CircularProgress, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip, Menu, MenuItem, Badge } from '@material-ui/core';
import { selectLoadingDatenvollsteandigkeit, selectLoadingKommunikation, selectBetriebsereignisListe, getBetriebsereignisse, getAktiveMesspunkte, selectAktiveMesspunkte, getBetriebsstatus, selectBetriebesstatusListe, selectMaxKommunication, selectMaxDatenvollsteandigkeit, 
    setSelectedMessstelle, selectSelectedMessstelle, selectNumberOfDevicesKommunikation, selectNumberOfDevicesDatenvollstaendigkeit, selectSort, setSort 
} from './betriebsereignisseSlice';
import { nsTSToLocalStringWithoutNS, nsTSToUTCStringWithoutNS } from '../../utils/utils';
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { getMessstellenForLookup, getMessstellenLookup, selectMessstellenLoadingLookup, selectMessstellenDictionary } from '../../features/messstellenLookup/messstellenLookupSlice';
import LegendeStoerung from '../../features/legende/legendeStoerung';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { betriebsstatus } from '../../utils/apiTypes';
import CachedIcon from '@material-ui/icons/Cached';
import { sortOrder, sortProp } from './betriebsereignisseTypes';

export default function Betriebsereignisse(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const [reload, setReload] = React.useState(false);


    useEffect(() => {
        dispatch(getBetriebsereignisse());
        dispatch(getMessstellenForLookup());
        dispatch(getAktiveMesspunkte());
        dispatch(getBetriebsstatus());
    }, [instance, reload]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };


    const getKommunikationIconForStateValue = (value: number) => {
        switch (value) {
            case 0:
                return (
                    <Tooltip title="Datenabruf funktioniert fehlerfrei" >
                        <CheckCircle style={{ color: "green" }} />
                    </Tooltip>)
            case 1:
                return (
                    <Tooltip title="Fehler beim Datenabruf, aber geplantes Netzereignis eingetragen" >
                        <Error style={{ color: "green" }} />
                    </Tooltip>)
            case 2:
                return (
                    <Tooltip title="Fehler beim Datenabruf" >
                        <Cancel className={classes.redSignalColor} />
                    </Tooltip>)
            default: return "";
        }
    };

    const getDatenvollstaendigkeitIconForStateValue = (value: number) => {
        switch (value) {
            case 0:
                return (
                    <Tooltip title="Messwerte sind aktuell" >
                        <CheckCircle style={{ color: "green" }} />
                    </Tooltip>)
            
            case 2:
                return (
                    <Tooltip title="Kein Dateneingang in den letzten 72 Stunden" >
                        <Cancel className={classes.redSignalColor} />
                    </Tooltip>)
            default: return "";
        }
    };

    const [showDatenSorting, setShowDatenSorting] = React.useState(false)
    const [showCommunicationSorting, setShowCommunicationSorting] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState<null | Element>(null);

    const loadingDatenvollsteandigkeit = useAppSelector(selectLoadingDatenvollsteandigkeit);
    const loadingKommunikation = useAppSelector(selectLoadingKommunikation);
    const betriebsStatusListe = useAppSelector(selectBetriebesstatusListe);
    const betriebsereignisListe = useAppSelector(selectBetriebsereignisListe);
    const generalKommunicationStatus = useAppSelector(selectMaxKommunication);
    const numberOfDevicesKommunikation = useAppSelector(selectNumberOfDevicesKommunikation);
    const generalDatenvollsteandigkeit = useAppSelector(selectMaxDatenvollsteandigkeit);
    const numberOfDevicesDatenvollstaendigkeit = useAppSelector(selectNumberOfDevicesDatenvollstaendigkeit);
    const selectedMessstelle = useAppSelector(selectSelectedMessstelle);

    const aktiveMesspunkte = useAppSelector(selectAktiveMesspunkte);

    const messstellenDict = useAppSelector(selectMessstellenDictionary);
    const messstellenLoadingLookup = useAppSelector(selectMessstellenLoadingLookup);
    const sort = useAppSelector(selectSort);

    const isUTC = useAppSelector(selectDate);

    const handleClick = (event: React.MouseEvent<Element, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };

    const btcMailDestination = process.env.REACT_APP_BTC_MAIL
    const siMailDestination = process.env.REACT_APP_SI_MAIL
    const asbMailDestination = process.env.REACT_APP_ASB_MAIL

    const generalMailHandler = (ms: betriebsstatus) => {
        const theActiveMesspunkt = (aktiveMesspunkte.find(act => act.name ===  ms.messstelle));
        const umspannwerk = theActiveMesspunkt !== undefined && theActiveMesspunkt.umspannwerk ? theActiveMesspunkt.umspannwerk : "nicht gesetzt";
        const schaltfeld = theActiveMesspunkt !== undefined && theActiveMesspunkt.schaltfeld ? theActiveMesspunkt.schaltfeld : "nicht gesetzt";
        const seriennummer = theActiveMesspunkt !== undefined && theActiveMesspunkt.messgeraetSeriennummer ? theActiveMesspunkt.messgeraetSeriennummer : "nicht gesetzt";
        const ipAdresse = theActiveMesspunkt !== undefined && theActiveMesspunkt.messgeraetIP ? theActiveMesspunkt.messgeraetIP : "nicht gesetzt";
        const routerSerienummer = theActiveMesspunkt !== undefined && theActiveMesspunkt.routerSeriennummer ? theActiveMesspunkt.routerSeriennummer : "nicht gesetzt";
        const routerIPAddresse = theActiveMesspunkt !== undefined && theActiveMesspunkt.routerIP ? theActiveMesspunkt.routerIP : "nicht gesetzt";

        const addCc = theActiveMesspunkt !== undefined && theActiveMesspunkt.routerIP ? `cc=${asbMailDestination}&` : "";
        const addRouter = theActiveMesspunkt !== undefined && theActiveMesspunkt.routerIP ?
        `Router Seriennummer: ${routerSerienummer} %0D%0A
        Router IP-Adresse: ${routerIPAddresse} %0D%0A
        Verbindung über INSYS` : 
        `Verbindung über IP@UW`

        //eslint-disable-next-line scanjs-rules/assign_to_href
        window.location.href = `mailto:${btcMailDestination}?${addCc}subject=Nicht erreichbares Messgerät&body=
        Uhrzeit: ${new Date().toLocaleString()} %0D%0A
        Umspannwerk: ${umspannwerk} %0D%0A
        Schaltfeld: ${schaltfeld} %0D%0A
        Name: ${ms.messstelle} %0D%0A
        Messgerät Seriennummer: ${seriennummer} %0D%0A
        Messgerät IP-Adresse: ${ipAdresse} %0D%0A
        ${addRouter}`
    }

    const iPUWMailHandler = (ms: betriebsstatus) => {
        const theActiveMesspunkt = (aktiveMesspunkte.find(act => act.name ===  ms.messstelle));
        const umspannwerk = theActiveMesspunkt !== undefined && theActiveMesspunkt.umspannwerk ? theActiveMesspunkt.umspannwerk : "nicht gesetzt";
        const schaltfeld = theActiveMesspunkt !== undefined && theActiveMesspunkt.schaltfeld ? theActiveMesspunkt.schaltfeld : "nicht gesetzt";
        const seriennummer = theActiveMesspunkt !== undefined && theActiveMesspunkt.messgeraetSeriennummer ? theActiveMesspunkt.messgeraetSeriennummer : "nicht gesetzt";
        const ipAdresse = theActiveMesspunkt !== undefined && theActiveMesspunkt.messgeraetIP ? theActiveMesspunkt.messgeraetIP : "nicht gesetzt";

        //eslint-disable-next-line scanjs-rules/assign_to_href
        window.location.href = `mailto:${siMailDestination}?subject=Nicht erreichbares Messgerät&body=
        Uhrzeit: ${new Date().toLocaleString()} %0D%0A
        Umspannwerk: ${umspannwerk} %0D%0A
        Schaltfeld: ${schaltfeld} %0D%0A
        Name: ${ms.messstelle} %0D%0A
        Messgerät Seriennummer: ${seriennummer} %0D%0A
        Messgerät IP-Adresse: ${ipAdresse} %0D%0A
        Verbindung über IP@UW`
    }

    return (
        <Container maxWidth={false} style={{ marginTop: "10px" }}>
            <Grid item container md={12}>
                <Grid item md={11} >
                    <Typography color="primary" variant="h5">
                    Betriebsereignisse
                    </Typography>
                </Grid>
                <Grid item md={12} >
                  <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "16px" }}>
                    <Button color="secondary" 
                    onClick={() => setReload(!reload)}>Neu Laden<CachedIcon style={{marginLeft: "10px"}}/></Button >
                  </Grid> 
                </Grid>
                <Grid item md={12} >
                    <LegendeStoerung name={"betriebsereignis"} />
                </Grid>
                <Grid item container md={12} spacing={2} className={classes.paddingPaper}>
                    
                    <Grid item md={7}>
                        <Paper style={{ minWidth: "100%", height: "82.5vh"}} >
                            <Grid item container md={12} style={{ height: "7.5vh" }}>
                                
                                        {loadingDatenvollsteandigkeit ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom} >
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Table>
                                        <TableBody>
                                            <TableRow hover={false}>
                                                <TableCell style={{ width: "30%"}}><Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Messstellen</Typography></TableCell>
                                                <TableCell style={{ width: "5%", alignContent:"right"}}><AssignmentTurnedIn color="primary" style={{marginLeft: "2.5em"}}/></TableCell>
                                                <TableCell style={{ width: "22.5%", textAlign:"left", alignContent: "left"}}>Datenvollständigkeit (10 Minuten)</TableCell>
                                                <TableCell style={{ width: "2.5%"}}><Badge badgeContent={numberOfDevicesDatenvollstaendigkeit} color="primary">{getDatenvollstaendigkeitIconForStateValue(generalDatenvollsteandigkeit)}</Badge></TableCell>
                                                <TableCell style={{ width: "10%"}}></TableCell>
                                                <TableCell style={{ width: "2.5%"}}><ForumIcon color="primary" /></TableCell>
                                                <TableCell style={{ width: "10%", textAlign: "left"}}>Kommunikation</TableCell>
                                                <TableCell style={{ width: "7.5%"}}><Badge badgeContent={numberOfDevicesKommunikation} color="primary">{getKommunikationIconForStateValue(generalKommunicationStatus)}</Badge></TableCell>
                                                <TableCell style={{ width: "10%"}}></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>)}
                            </Grid>
                            {loadingKommunikation || messstellenLoadingLookup ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer style={{ height: "75vh"}}>
                                        <Table stickyHeader size="small" >
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", maxWidth: "20px", width: "10px", padding: "0px", paddingLeft: "15px" }}><AssignmentTurnedIn color="primary" /><ImportExportIcon  style={{cursor: "pointer"}} onClick={(e) => {setShowDatenSorting(!showDatenSorting); setShowCommunicationSorting(false); handleClick(e)}}/></TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", maxWidth: "20px", width: "10px", padding: "0px", paddingLeft: "15px" }}><ForumIcon color="primary" /><ImportExportIcon style={{cursor: "pointer"}} onClick={(e) => {setShowCommunicationSorting(!showCommunicationSorting);  setShowDatenSorting(false); handleClick(e)}}/></TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "190px" }}>Umspannwerk</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "190px" }}>Schaltfeld</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "100px" }}>Messstelle</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "190px" }} >Aktion</TableCell>
                                            </TableHead>
                                            {showDatenSorting ? 
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    keepMounted
                                                    open={Boolean(anchorEl)}
                                                    onClose={() => setShowDatenSorting(false)}
                                                    >
                                                    <MenuItem className={sort.sortOrder == null || sort.sortProp != sortProp.datenvollstaendigkeit ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.datenvollstaendigkeit, sortOrder: null})); setShowDatenSorting(false);}}>
                                                        Sortierung deaktivieren
                                                    </MenuItem>
                                                    <MenuItem className={sort.sortProp == sortProp.datenvollstaendigkeit && sort.sortOrder == sortOrder.errorFirst ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.datenvollstaendigkeit, sortOrder: sortOrder.errorFirst})); setShowDatenSorting(false);}}>
                                                        Fehler zuerst
                                                    </MenuItem>
                                                    <MenuItem className={sort.sortProp == sortProp.datenvollstaendigkeit && sort.sortOrder == sortOrder.errorLast ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.datenvollstaendigkeit, sortOrder: sortOrder.errorLast})); setShowDatenSorting(false);}}>
                                                        Fehlerfrei zuerst
                                                    </MenuItem>
                                                </Menu> : ""}
                                            {showCommunicationSorting ? 
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    keepMounted
                                                    open={Boolean(anchorEl)}
                                                    onClose={() => setShowCommunicationSorting(false)}
                                                    >
                                                    <MenuItem className={sort.sortOrder == null || sort.sortProp != sortProp.kommunikation ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.kommunikation, sortOrder: null})); setShowCommunicationSorting(false);}}>
                                                        Sortierung deaktivieren
                                                    </MenuItem>
                                                    <MenuItem className={sort.sortProp == sortProp.kommunikation && sort.sortOrder == sortOrder.errorFirst ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.kommunikation, sortOrder: sortOrder.errorFirst})); setShowCommunicationSorting(false);}}>
                                                        Fehler zuerst
                                                    </MenuItem>
                                                    <MenuItem className={sort.sortProp == sortProp.kommunikation && sort.sortOrder == sortOrder.errorLast ? classes.menuItemSelected : ""}
                                                        onClick={() => {dispatch(setSort({ sortProp: sortProp.kommunikation, sortOrder: sortOrder.errorLast})); setShowCommunicationSorting(false);}}>
                                                        Fehlerfrei zuerst
                                                    </MenuItem>
                                                </Menu> : ""}
                                            <TableBody >
                                                {betriebsStatusListe.map((ms) => (
                                                    <TableRow key={ms.messstelle} hover={true} selected={ms.messstelle === selectedMessstelle} >
                                                        <TableCell>{getDatenvollstaendigkeitIconForStateValue(ms.datenvollstaendigkeit)}</TableCell>
                                                        <TableCell>{getKommunikationIconForStateValue(ms.kommunikation)}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, ms.messstelle, "umspannwerk")}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, ms.messstelle, "schaltfeld")}</TableCell>
                                                        <TableCell>{ms.messstelle}</TableCell>
                                                        <TableCell>
                                                            <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
                                                                <Button color="secondary" onClick={() => dispatch(setSelectedMessstelle(ms.messstelle))}>zeige Ereignisse</Button>
                                                                {ms.datenvollstaendigkeit == 2 && !messstellenLoadingLookup ?
                                                                    <div>
                                                                        {aktiveMesspunkte.find(act => act.name ===  ms.messstelle)?.routerIP == null ?
                                                                            <Tooltip title="Störungsmeldung an SI Help Desk"><MailOutlineIcon onClick={() => iPUWMailHandler(ms)} style={{marginLeft: "10px", cursor: "pointer"}}/></Tooltip> : "" }
                                                                        <Tooltip title="Störungsmeldung an BTC Service Desk"><MailOutlineIcon onClick={() => generalMailHandler(ms)} style={{marginLeft: "10px", cursor: "pointer"}}/></Tooltip>
                                                                    </div> : ""}
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>
                    <Grid item md={5}>
                      
                      { selectedMessstelle != "" && betriebsereignisListe.length > 0 ?  
                      <Paper style={{ minWidth: "100%", height: "82.5vh" }} >
                            <Grid item container md={12}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{ width: "100%", justifyContent: "left"}}><Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }}>Ereignisse </Typography>
                                            <p style={{ fontSize: "16px", color: "black" }}> { getMessstellenLookup(messstellenDict, selectedMessstelle, "umspannwerk") + " " + getMessstellenLookup(messstellenDict, selectedMessstelle, "schaltfeld") + " (" + selectedMessstelle + ")" } </p>
                                            </TableCell>
                                        </TableRow>
                                        
                                    </TableBody>
                                </Table>
                            </Grid>
                            {loadingKommunikation && messstellenLoadingLookup ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer className={classes.heightScrolledTableBottom} style={{ height: selectedMessstelle !== "" ? "31.75em" :  "34.5em"}}>
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "10%" }}>Status</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "5%" }}></TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", paddingRight: "0px", width: "10%" }}>Ereignis</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "5%" }}></TableCell> 
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", width: "70%"}}>Beschreibung</TableCell>                                             
                                            </TableHead>
                                            <TableBody>
                                                {selectedMessstelle != "" && betriebsereignisListe.length > 0 ? betriebsereignisListe.filter((e) => e.messstelle == selectedMessstelle || e.messstelle == null).map((be, index) => (
                                                    <TableRow hover={true}  key={index} >
                                                        <TableCell style={{width: "10%"}}>{be.typ ? getDatenvollstaendigkeitIconForStateValue(be.status) : getKommunikationIconForStateValue(be.status)}</TableCell>
                                                        <TableCell style={{width: "5%"}}></TableCell>
                                                        <TableCell style={{ width: "10%", paddingRight: "0px" }}>{be.typ ? (<AssignmentTurnedIn color="primary">Datenvollständigkeit</AssignmentTurnedIn>) : (<ForumIcon color="primary" >Kommunikation</ForumIcon>)}</TableCell>
                                                        <TableCell style={{width: "5%"}}></TableCell>
                                                        <TableCell style={{width: "70%"}}>{be.typ ? "Letzter Eintrag für Datenklasse " : ""}{be.beschreibung + ": " + (isUTC ? nsTSToUTCStringWithoutNS(be.zeit) : nsTSToLocalStringWithoutNS(be.zeit))}</TableCell>
                                                    </TableRow>
                                                )) : ""
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper> : 
                        
                        loadingKommunikation ||  messstellenLoadingLookup ? 
                        (<TableContainer className={classes.heightScrolledTableBottom}>
                            <Table stickyHeader style={{ overflow: "hidden" }}>
                                <TableHead>
                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                </TableHead>
                            </Table>
                        </TableContainer>) :
                        (<Paper style={{ minWidth: "100%" }}>
                        <TableContainer  style={{ height: "82.5vh"}}>
                                        <Table stickyHeader size="small" >
                                            <TableHead>
                                                <TableCell style={{fontWeight: "600", fontSize: "18px", backgroundColor: "white", textAlign: "center", border: "none", paddingTop: "5em"}}>Bitte wählen Sie eine Messstelle aus, um deren Details anzuzeigen.</TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer></Paper>)}
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}